import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="regulatory_updates" />;

export const Route = createFileRoute("/en/regulatory-updates/$slug")({
  loader: ({ params }) => loadContentMeta("regulatory_updates", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/regulatory-updates/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

